var _path, _path2, _rect, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFitWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.06509 12.5341C1.9783 12.4462 1.9783 12.3038 2.06509 12.2159L2.95398 11.3159C3.04076 11.228 3.18146 11.228 3.26825 11.3159C3.35503 11.4038 3.35503 11.5462 3.26825 11.6341L2.75871 12.15L4.77778 12.15C4.90051 12.15 5 12.2507 5 12.375C5 12.4993 4.90051 12.6 4.77778 12.6L2.75871 12.6L3.26825 13.1159C3.35503 13.2038 3.35503 13.3462 3.26825 13.4341C3.18146 13.522 3.04076 13.522 2.95398 13.4341L2.06509 12.5341Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.5L5 10.5",
    stroke: "#28303F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7.5,
    width: 11,
    height: 10,
    rx: 2,
    stroke: "#28303F",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9349 12.4659C23.0217 12.5538 23.0217 12.6962 22.9349 12.7841L22.046 13.6841C21.9592 13.772 21.8185 13.772 21.7318 13.6841C21.645 13.5962 21.645 13.4538 21.7318 13.3659L22.2413 12.85L20.2222 12.85C20.0995 12.85 20 12.7493 20 12.625C20 12.5007 20.0995 12.4 20.2222 12.4L22.2413 12.4L21.7318 11.8841C21.645 11.7962 21.645 11.6538 21.7318 11.5659C21.8185 11.478 21.9592 11.478 22.046 11.5659L22.9349 12.4659Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5V14.5",
    stroke: "#28303F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitWidth);
export default __webpack_public_path__ + "static/media/fitWidth.ceccabbbaf0e0072cbad4512aafd9150.svg";
export { ForwardRef as ReactComponent };